import { render, staticRenderFns } from "./OverviewSubheader.vue?vue&type=template&id=b715c00a&scoped=true&lang=html&"
import script from "./OverviewSubheader.vue?vue&type=script&lang=js&"
export * from "./OverviewSubheader.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSubheader.vue?vue&type=style&index=0&id=b715c00a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b715c00a",
  null
  
)

export default component.exports